export const useReferral = () => {
  const config = useRuntimeConfig().public
  const client = useFetchClient(config.majorityWebMinorityUrl, 'Majority Web Minority API - Referrals')

  const getReferralDetails = async (referralLinkId) => {
    try {
      const resource = `/v1/referral/${referralLinkId}/referral-link-info`
      const response = await client.get(resource)
      if (response.errorId) {
        return null
      } else {
        return response
      }
    } catch (error) {
      return null
    }
  }

  const sendReferralDetails = async (referralLinkId, accessToken) => {
    // 0 - successfull, 1 - already registered, 2 - existing user, 3 - other error
    const url = `/v1/referral/${referralLinkId}/register-referral-link`
    const headers = { Authorization: `Bearer ${accessToken}` }
    const response = await client.put(url, {}, headers)
    if (response && response.errorId) {
      if (response.errorId === '6838CED4-BD1E-4938-9836-9F1DE40C1F88') {
        return 1
      } else if (response.errorId === '52B9D83B-0A5E-4A0D-B129-32D65D388A18') {
        return 2
      } else {
        return 3
      }
    }
    return 0
  }

  return {
    getReferralDetails,
    sendReferralDetails
  }
}
